import {TModal} from "../types/common.type";
import {ICreateAndUpdateParent} from "./../types/parent.interface";
import React from "react";

interface IParentContext {
  refetch?: any;
  showModal?: TModal;
  isLoading?: boolean;
  setShowModal?: React.Dispatch<React.SetStateAction<TModal>>;
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  requestParent?: any;
  selectedParent?: any;
  createFunction?: (formData: ICreateAndUpdateParent) => void;
  updateFunction?: (formData: ICreateAndUpdateParent) => void;
  deleteFunction?: (userID: string) => void;
  setRequestParent?: any;
  setSelectedParent?: any;
}

const ParentScreen = React.createContext<IParentContext>({});

export default ParentScreen;
